<template>
  <div
    class="row"
    v-bind:style="{
      color:
        settings_style.colors != undefined
          ? settings_style.colors[4].color_value
          : 'white',
    }"
  >
    <div class="col-12">
      <div class="d-flex w-100 custom-info-two">
        <div class="col-4 pl-0">
          <table>
            <tr>
              <th class="pr-3">Vendedor:</th>
              <td
                class="table-item pl-3"
                v-bind:style="{
                  color:
                    settings_style.colors != undefined
                      ? settings_style.colors[4].color_value
                      : 'white',
                }"
              >
                <div v-if="quote_data != undefined">
                  <span
                    v-if="
                      quote_data.owner.name != null &&
                      quote_data.owner.name != undefined
                    "
                  >
                    {{ quote_data.owner.name }} {{ quote_data.owner.last_name }}
                  </span>
                </div>
                <span v-else> Nombre del vendedor </span>
              </td>
            </tr>
            <tr>
              <th class="pr-3">Empresa:</th>
              <td
                class="table-item pl-3"
                v-bind:style="{
                  color:
                    settings_style.colors != undefined
                      ? settings_style.colors[4].color_value
                      : 'white',
                }"
              >
                <div v-if="quote_data != undefined">
                  <span
                    v-if="
                      quote_data.owner.company != undefined &&
                      quote_data.owner.company != null
                    "
                  >
                    {{ quote_data.owner.company }}
                  </span>
                </div>
                <span v-else> Nombre de la empresa </span>
              </td>
            </tr>
            <tr>
              <th class="pr-3">Dirección:</th>
              <td
                class="table-item pl-3"
                v-bind:style="{
                  color:
                    settings_style.colors != undefined
                      ? settings_style.colors[4].color_value
                      : 'white',
                }"
              >
                <div v-if="quote_data != undefined">
                  <span
                    v-if="
                      quote_data.owner.address != undefined &&
                      quote_data.owner.address != null
                    "
                  >
                    {{ quote_data.owner.address }}
                  </span>
                </div>
                <span v-else>
                  Dirección de la empresa
                  <br />
                  Colonia y todo eso...
                </span>
              </td>
            </tr>
            <tr>
              <th class="pr-3">Página Web:</th>
              <td
                class="pl-3"
                v-bind:style="{
                  color:
                    settings_style.colors != undefined
                      ? settings_style.colors[4].color_value
                      : 'white',
                }"
              >
                <div v-if="quote_data != undefined">
                  <a
                    :href="quote_data.owner.page"
                    v-if="
                      quote_data.owner.page != undefined &&
                      quote_data.owner.page != null
                    "
                    v-bind:style="{
                      color:
                        settings_style.colors != undefined
                          ? settings_style.colors[4].color_value
                          : 'white',
                    }"
                  >
                    {{ quote_data.owner.page }}
                  </a>
                </div>
                <span v-else> www.paginaweb.com </span>
              </td>
            </tr>
          </table>
        </div>

        <div class="ml-5" v-if="quote_data != undefined">
          <table
            class="mb-2"
            v-for="client in quote_data.clients"
            :key="client.email"
          >
            <tr>
              <th class="pr-3">Cliente:</th>
              <td
                class="table-item pl-3"
                v-bind:style="{
                  color:
                    settings_style.colors != undefined
                      ? settings_style.colors[4].color_value
                      : 'white',
                }"
              >
                {{ client.name }} {{ client.last_name }} 
              </td>
            </tr>
            <tr>
              <th class="pr-3">Empresa:</th>
              <td
                class="table-item pl-3"
                v-bind:style="{
                  color:
                    settings_style.colors != undefined
                      ? settings_style.colors[4].color_value
                      : 'white',
                }"
              >
                {{ client.company }}
              </td>
            </tr>
            <tr>
              <th class="pr-3">E-mail:</th>
              <td
                class="table-item pl-3"
                v-bind:style="{
                  color:
                    settings_style.colors != undefined
                      ? settings_style.colors[4].color_value
                      : 'white',
                }"
              >
                {{ client.email }}
              </td>
            </tr>
          </table>
        </div>

        <div class="ml-5" v-else>
          <table>
            <tr>
              <th class="pr-3">Cliente:</th>
              <td
                class="table-item pl-3"
                v-bind:style="{
                  color:
                    settings_style.colors != undefined
                      ? settings_style.colors[4].color_value
                      : 'white',
                }"
              >
                Nombre del cliente
              </td>
            </tr>
            <tr>
              <th class="pr-3">Empresa:</th>
              <td
                class="table-item pl-3"
                v-bind:style="{
                  color:
                    settings_style.colors != undefined
                      ? settings_style.colors[4].color_value
                      : 'white',
                }"
              >
                Empresa del cliente
              </td>
            </tr>
            <tr>
              <th class="pr-3">E-mail:</th>
              <td
                class="table-item pl-3"
                v-bind:style="{
                  color:
                    settings_style.colors != undefined
                      ? settings_style.colors[4].color_value
                      : 'white',
                }"
              >
                Email del cliente
              </td>
            </tr>
          </table>
        </div>

        <div
          class="ml-auto col-3"
          v-if="settings_style.view_notes && quote_data != undefined"
        >
          <div
            class="notes-wrapper p-4"
            v-bind:style="{
              color:
                settings_style.colors != undefined
                  ? settings_style.colors[4].color_value
                  : 'white',
            }"
            v-if="quote_data.details.notes != null"
          >
            NOTAS:
            <div v-html="quote_data.details.notes"></div>
          </div>
        </div>
        <div class="col-4" v-else-if="settings_style.view_notes">
          <div
            class="notes-wrapper"
            v-bind:style="{
              color:
                settings_style.colors != undefined
                  ? settings_style.colors[4].color_value
                  : 'white',
            }"
          >
            <p>NOTAS:</p>
            <div>Lorem ipsum dolor sit amet consectetur adipisicing elit</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    settings_style: {
      required: true,
    },
    quote_data: {
      type: Object,
    },
  },
};
</script>